// 지점 접근 권한
export const permissionsKeys = {
  all: () => ["permissions"],

  // [GET] 지점 접근 권한 가져오기
  branchAccess: () => [...permissionsKeys.all(), "branchAccess"],
};
